import { render, staticRenderFns } from "./actorselect.vue?vue&type=template&id=9a154840&scoped=true&"
import script from "./actorselect.vue?vue&type=script&lang=js&"
export * from "./actorselect.vue?vue&type=script&lang=js&"
import style0 from "./actorselect.vue?vue&type=style&index=0&id=9a154840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a154840",
  null
  
)

export default component.exports